import React, { useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import MaterialTable from "material-table";
import { tableIcons, getTableHeader } from "../utils/tableHeaders";
import { createExportActions } from "./DataTable";

/**
 * Free trial subscriptions table component with date filter
 */
export const TrialSubsTable = ({ data, selectedRows = [] }) => {
  const [trialFilterCheckmark, setTrialFilterCheckmark] = useState(false);

  if (!data || data.length === 0) {
    return null;
  }

  const filteredData = trialFilterCheckmark
    ? data.filter(
        (row) =>
          moment(new Date(+row.startDate)).valueOf() >=
          moment().subtract(3, "weeks").valueOf()
      )
    : data;

  const tableData = selectedRows.length > 0
    ? filteredData.map((row) =>
        selectedRows.find((selected) => selected.id === row.id)
          ? { ...row, tableData: { checked: true } }
          : row
      )
    : filteredData;

  const actions = [
    {
      isFreeAction: true,
      icon: tableIcons.Filter,
      tooltip: "Filter Dates By 3 Weeks",
      onClick: () => {
        setTrialFilterCheckmark(!trialFilterCheckmark);
      },
    },
    ...createExportActions("trialSubs", "Free Trial Users"),
  ];

  return (
    <div style={{ width: "100%" }}>
      <MaterialTable
        style={{ marginTop: "10px", marginBottom: "10px" }}
        icons={tableIcons}
        key="trialSubsTable"
        title={
          <div style={{ marginTop: "10px" }}>
            <h2>Free Trial Users</h2>
            <p style={{ fontSize: "125%" }}>
              Users that are/were enrolled in a Free Trial
            </p>
            <p style={{ fontSize: "125%" }}>
              The # of Students/Sessions/S&M is during the 14-day trial period
              and not overall
            </p>
          </div>
        }
        columns={getTableHeader("trialSubs")}
        data={tableData}
        options={{
          selection: true,
          sorting: true,
        }}
        actions={actions}
      />
    </div>
  );
};

TrialSubsTable.propTypes = {
  data: PropTypes.array.isRequired,
  selectedRows: PropTypes.array,
};

